import * as _ from 'underscore';
import moment from 'moment';
import {
    redzoneTypes,
    redzones,
    weightParamTypes,
    workoutParamTypes
} from './paramTypes';
import { TYPES as PROGRAM_TYPES } from '../state/reducer/calendar/programTypes';

const alphabet = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    'AA',
    'AB',
    'AC',
    'AD',
    'AE',
    'AF',
    'AG',
    'AH',
    'AI',
    'AJ',
    'AK',
    'AL',
    'AM',
    'AN',
    'AO',
    'AP',
    'AQ',
    'AR',
    'AS',
    'AT',
    'AU',
    'AV',
    'AW',
    'AX',
    'AY',
    'AZ'
];

export const BlockTypes = {
    UNCATEGORIZED: 0,
    PREP: 1,
    SPEED_AGILITY: 2,
    SKILL_TECH: 3,
    STRENGTH_POWER: 4,
    CONDITIONING: 5,
    RECOVERY: 6,
    SURVEY: 7,
    BIOMETRIC: 8
};

export const BlockTypeTitles = [
    'Uncategorized',
    'Prep',
    'Speed/Agility',
    'Skill/Tech',
    'Strength/Power',
    'Conditioning',
    'Recovery',
    'Survey',
    'Biometric'
];

export const getKey = function() {
    const key = `k::${Math.floor(Math.random() * 10000 + 1)}`;
    return key;
};

export const isCustomBlockTitle = function(title) {
    return BlockTypeTitles.indexOf(title) < 0;
};

export const isText = function(type) {
    return type === 1;
};
export const isTables = function(type) {
    return type === 3 || type === 0 || type === null;
};
export const isTextResult = function(type) {
    return type === 2;
};

export const isBlockTypeTextResult = function(type) {
    return (
        type === BlockTypes.CONDITIONING ||
        type === BlockTypes.SPEED_AGILITY ||
        type === BlockTypes.SKILL_TECH ||
        type === BlockTypes.BIOMETRIC ||
        type === BlockTypes.SURVEY
    );
};

export const isBlockTypeTextOnly = function(type) {
    return type === BlockTypes.PREP || type === BlockTypes.RECOVERY;
};

export const getDayKey = function(day) {
    if (day.date_rescheduled) {
        const y = moment(day.date_rescheduled).format('YYYY');
        const d = moment(day.date_rescheduled).format('D');
        const m = moment(day.date_rescheduled).format('M');
        return `${y}_${m}_${d}`;
    } else if (moment.isMoment(day)) {
        const y = day.format('YYYY');
        const d = day.format('D');
        const m = day.format('M');
        return `${y}_${m}_${d}`;
    } else if (
        day.year &&
        day.month &&
        day.day &&
        day.year !== '' &&
        day.month !== '' &&
        day.day !== ''
    ) {
        const y = parseInt(day.year);
        const m = parseInt(day.month);
        const d = parseInt(day.day);
        return `${y}_${m}_${d}`;
    } else if (day.timeline_day) {
        const timelineDay = day.timeline_day;
        const indexDay = timelineDay - 1;
        day.weekIndex = Math.floor(indexDay / 7);
        day.index = indexDay - day.weekIndex * 7;
        return `${day.weekIndex}_${day.index}`;
    }

    return `${day.weekIndex}_${day.index}`;
};

export const getDayIndexesFromTimelineDay = function(timelineDay) {
    const indexDay = timelineDay - 1;
    const weekIndex = Math.floor(indexDay / 7);
    const index = indexDay - weekIndex * 7;
    return { index, weekIndex };
};

export const splitDayKey = function(dayKey) {
    const splits = dayKey.split('_');
    if (splits.length === 3) {
        return {
            day: splits[2],
            month: splits[1],
            year: splits[0]
        };
    }

    return {
        weekIndex: splits[0],
        dayIndex: splits[1]
    };
};

export const getDayKeyFromTimelineDay = timelineDay => {
    let weekIndex;
    if (timelineDay % 7 === 0) {
        weekIndex = Math.floor(timelineDay / 7) - 1;
    } else {
        weekIndex = Math.floor(timelineDay / 7);
    }

    let dayIndex;
    if (timelineDay % 7 === 0) {
        dayIndex = 6;
    } else if (timelineDay > 7) {
        dayIndex = (timelineDay % 7) - 1;
    } else {
        dayIndex = timelineDay - 1;
    }

    return `${weekIndex}_${dayIndex}`;
};

export const getMonthTitle = function(month) {
    if (month === 1) {
        return 'January';
    } else if (month === 2) {
        return 'February';
    } else if (month === 3) {
        return 'March';
    } else if (month === 4) {
        return 'April';
    } else if (month === 5) {
        return 'May';
    } else if (month === 6) {
        return 'June';
    } else if (month === 7) {
        return 'July';
    } else if (month === 8) {
        return 'August';
    } else if (month === 9) {
        return 'September';
    } else if (month === 10) {
        return 'October';
    } else if (month === 11) {
        return 'November';
    } else if (month === 12) {
        return 'December';
    }
};

export const getBlockTitle = function(index) {
    return alphabet[index];
};

export const getBlockTitleWithFallback = function(block) {
    if (
        (block.title === '' || block.title.length === 1) &&
        block.title.workout_combo_id === null
    ) {
        if (block.type === BlockTypes.UNCATEGORIZED) {
            return 'Circuit';
        }
        return getBlockTypeText(block);
    }
    return block.title;
};

export const isLast = function(position, size) {
    return position + 1 === size;
};

export const isFirst = function(position) {
    return position === 0;
};

export const isSubscription = function(session, programType) {
    if (
        session.program_type === PROGRAM_TYPES.CALENDAR &&
        programType !== PROGRAM_TYPES.CALENDAR
    ) {
        return true;
    }

    const isSubscription =
        session.program_type !== PROGRAM_TYPES.FIXED &&
        (session.teamSubscription ||
            session.subscription ||
            session.group_team_subscription_id !== null);

    return isSubscription;
};

export const hasOne = function(size) {
    return size === 1;
};

export const hasNone = function(size) {
    return size === 0;
};

export const hasMultiple = function(size) {
    return size > 1;
};

export const getBlockTypeText = function(block) {
    if (block.type === BlockTypes.UNCATEGORIZED) {
        return 'Uncategorized';
    } else if (block.type === BlockTypes.PREP) {
        return 'Prep';
    } else if (block.type === BlockTypes.SPEED_AGILITY) {
        return 'Speed/Agility';
    } else if (block.type === BlockTypes.SKILL_TECH) {
        return 'Skill/Tech';
    } else if (block.type === BlockTypes.STRENGTH_POWER) {
        return 'Strength/Power';
    } else if (block.type === BlockTypes.CONDITIONING) {
        return 'Conditioning';
    } else if (block.type === BlockTypes.RECOVERY) {
        return 'Recovery';
    } else if (block.type === BlockTypes.SURVEY) {
        return 'Survey';
    } else if (block.type === BlockTypes.BIOMETRIC) {
        return 'Biometric';
    }
    return 'Uncategorized';
};

export const getRedzoneType = typeId => _.find(redzoneTypes, { id: typeId });

export const getRedzoneTypeTitle = id => {
    let redzoneType = getRedzoneType(id);
    return redzoneType.title;
};

export const getBlockPlaceholderText = block => {
    if (block.type === BlockTypes.PREP) {
        // eslint-disable-next-line
        return 'EX.\n3 Rounds Not for Time\n10 Shoulder Pass Thrus\n10 Reverse Lunges\n10 Dead Bugs';
    } else if (block.type === BlockTypes.RECOVERY) {
        // eslint-disable-next-line
        return 'EX.\n400 M Walk, then:\n3 Rounds\n1:00 Couch Stretch\n1:00 Lat Stretch\n1:00 Rope Hamstring Stretch';
    } else if (block.type === BlockTypes.SPEED_AGILITY) {
        // eslint-disable-next-line
        return 'EX.\n3 Rounds\n10 Hurdle Hops\nRest 1 Minute\n20s Pogo Hops\nRest 1 Minute\n10 Speed Lunges\nRest 1 minute';
    } else if (block.type === BlockTypes.STRENGTH_POWER) {
        // eslint-disable-next-line
        return 'EX.\n10 of Each:\nPushups\nPrisoner Squats\nV-Sits\nBack Hypers';
    } else if (block.type === BlockTypes.SKILL_TECH) {
        // eslint-disable-next-line
        return 'EX.\n3 Rounds\n10 Target Throws\n10 Zig Zag Drill\n10 Y Cone Drill\n10 Shadow Agility';
    }
    // eslint-disable-next-line
    return 'EX.\n 3 Rounds for Time \n 400m Run \n 21 Kettlebell swings 54/36';
};

export const getSchemeId = function(setExercise, schemes) {
    const setExerciseAbr = calculateAbr(setExercise);
    let foundSchemeId = null; // set custom if we cannot find

    const foundScheme = _.findWhere(schemes, {
        abr: setExerciseAbr,
        param_count: setExercise.param_count
    });
    if (foundScheme) {
        foundSchemeId = foundScheme.id;
    } else {
        foundSchemeId = null;
    }

    return foundSchemeId;
};

export const calculateAbr = function(setExercise) {
    let abr = null;
    let abr2 = null;
    if (setExercise.no_sets === 1) {
        abr = 'For Completion';
    } else if (
        setExercise.param_1_type !== 0 &&
        setExercise.param_2_type !== 0
    ) {
        const theFirstParams = buildParamArray(
            setExercise.param_count,
            setExercise.param_1_type,
            setExercise.param_1_data_1,
            setExercise.param_1_data_2,
            setExercise.param_1_data_3,
            setExercise.param_1_data_4,
            setExercise.param_1_data_5,
            setExercise.param_1_data_6,
            setExercise.param_1_data_7,
            setExercise.param_1_data_8,
            setExercise.param_1_data_9,
            setExercise.param_1_data_10
        );
        const theSecondParams = buildParamArray(
            setExercise.param_count,
            setExercise.param_2_type,
            setExercise.param_2_data_1,
            setExercise.param_2_data_2,
            setExercise.param_2_data_3,
            setExercise.param_2_data_4,
            setExercise.param_2_data_5,
            setExercise.param_2_data_6,
            setExercise.param_2_data_7,
            setExercise.param_2_data_8,
            setExercise.param_2_data_9,
            setExercise.param_2_data_10
        );
        abr = calculateScheme(setExercise.param_1_type, theFirstParams);
        abr2 = calculateScheme(setExercise.param_2_type, theSecondParams, true);
    } else if (setExercise.param_1_type !== 0) {
        const theParams = buildParamArray(
            setExercise.param_count,
            setExercise.param_1_type,
            setExercise.param_1_data_1,
            setExercise.param_1_data_2,
            setExercise.param_1_data_3,
            setExercise.param_1_data_4,
            setExercise.param_1_data_5,
            setExercise.param_1_data_6,
            setExercise.param_1_data_7,
            setExercise.param_1_data_8,
            setExercise.param_1_data_9,
            setExercise.param_1_data_10
        );
        abr = calculateScheme(setExercise.param_1_type, theParams);
    } else if (setExercise.param_2_type !== 0) {
        const theParams = buildParamArray(
            setExercise.param_2_type,
            setExercise.param_2_data_1,
            setExercise.param_2_data_2,
            setExercise.param_2_data_3,
            setExercise.param_2_data_4,
            setExercise.param_2_data_5,
            setExercise.param_2_data_6,
            setExercise.param_2_data_7,
            setExercise.param_2_data_8,
            setExercise.param_2_data_9,
            setExercise.param_2_data_10
        );
        abr = calculateScheme(setExercise.param_2_type, theParams);
    } else if (
        setExercise.param_1_type === '0' &&
        setExercise.param_2_type === '0'
    ) {
        abr = null;
    } else if (
        setExercise.param_1_type !== '0' ||
        setExercise.param_2_type !== '0'
    ) {
        abr = '';
    } else {
        abr = 'NO MATCH';
    }

    if (
        setExercise.param_count > 0 &&
        ((abr === '' && abr2 === null) ||
            (abr === null && abr2 === '') ||
            (abr === null && abr2 === '') ||
            (abr === '' && abr2 === '') ||
            (abr === null && abr2 === null))
    ) {
        return calculateParamCountAbr(setExercise);
    }

    if (!abr && !abr2) {
        return '';
    }

    if (!abr) {
        return abr2;
    }
    if (!abr2) {
        return abr;
    }

    return `${abr} ${abr2}`;
};

export const calculateAbrToSave = function(setExercise) {
    let abr = null;
    let abr2 = null;
    if (setExercise.no_sets === 1) {
        abr = 'For Completion';
    } else if (
        setExercise.param_1_type !== 0 &&
        setExercise.param_2_type !== 0
    ) {
        const theFirstParams = buildParamArray(
            setExercise.param_count,
            setExercise.param_1_type,
            setExercise.param_1_data_1,
            setExercise.param_1_data_2,
            setExercise.param_1_data_3,
            setExercise.param_1_data_4,
            setExercise.param_1_data_5,
            setExercise.param_1_data_6,
            setExercise.param_1_data_7,
            setExercise.param_1_data_8,
            setExercise.param_1_data_9,
            setExercise.param_1_data_10
        );
        const theSecondParams = buildParamArray(
            setExercise.param_count,
            setExercise.param_2_type,
            setExercise.param_2_data_1,
            setExercise.param_2_data_2,
            setExercise.param_2_data_3,
            setExercise.param_2_data_4,
            setExercise.param_2_data_5,
            setExercise.param_2_data_6,
            setExercise.param_2_data_7,
            setExercise.param_2_data_8,
            setExercise.param_2_data_9,
            setExercise.param_2_data_10
        );
        abr = calculateSchemeToSave(setExercise.param_1_type, theFirstParams);
        abr2 = calculateSchemeToSave(
            setExercise.param_2_type,
            theSecondParams,
            true
        );
    } else if (setExercise.param_1_type !== 0) {
        const theParams = buildParamArray(
            setExercise.param_count,
            setExercise.param_1_type,
            setExercise.param_1_data_1,
            setExercise.param_1_data_2,
            setExercise.param_1_data_3,
            setExercise.param_1_data_4,
            setExercise.param_1_data_5,
            setExercise.param_1_data_6,
            setExercise.param_1_data_7,
            setExercise.param_1_data_8,
            setExercise.param_1_data_9,
            setExercise.param_1_data_10
        );
        abr = calculateSchemeToSave(setExercise.param_1_type, theParams);
    } else if (setExercise.param_2_type !== 0) {
        const theParams = buildParamArray(
            setExercise.param_2_type,
            setExercise.param_2_data_1,
            setExercise.param_2_data_2,
            setExercise.param_2_data_3,
            setExercise.param_2_data_4,
            setExercise.param_2_data_5,
            setExercise.param_2_data_6,
            setExercise.param_2_data_7,
            setExercise.param_2_data_8,
            setExercise.param_2_data_9,
            setExercise.param_2_data_10
        );
        abr = calculateSchemeToSave(setExercise.param_2_type, theParams);
    } else if (
        setExercise.param_1_type === '0' &&
        setExercise.param_2_type === '0'
    ) {
        abr = null;
    } else if (
        setExercise.param_1_type !== '0' ||
        setExercise.param_2_type !== '0'
    ) {
        abr = '';
    } else {
        abr = 'NO MATCH';
    }

    if (
        setExercise.param_count > 0 &&
        ((abr === '' && abr2 === null) ||
            (abr === null && abr2 === '') ||
            (abr === null && abr2 === '') ||
            (abr === '' && abr2 === '') ||
            (abr === null && abr2 === null))
    ) {
        return calculateParamCountAbr(setExercise);
    }

    if (!abr && !abr2) {
        return '';
    }

    if (!abr) {
        return abr2;
    }
    if (!abr2) {
        return abr;
    }

    return `${abr} ${abr2}`;
};

function buildParamArray(
    numSets,
    type,
    p1,
    p2,
    p3,
    p4,
    p5,
    p6,
    p7,
    p8,
    p9,
    p10
) {
    const theParams = [];
    if ((p1 !== null && p1 !== '' && p1 !== '0') || numSets > 0) {
        theParams.push(buildParamViewTime(type, p1));
    }
    if ((p2 !== null && p2 !== '' && p2 !== '0') || numSets > 1) {
        theParams.push(buildParamViewTime(type, p2));
    }
    if ((p3 !== null && p3 !== '' && p3 !== '0') || numSets > 2) {
        theParams.push(buildParamViewTime(type, p3));
    }
    if ((p4 !== null && p4 !== '' && p4 !== '0') || numSets > 3) {
        theParams.push(buildParamViewTime(type, p4));
    }
    if ((p5 !== null && p5 !== '' && p5 !== '0') || numSets > 4) {
        theParams.push(buildParamViewTime(type, p5));
    }
    if ((p6 !== null && p6 !== '' && p6 !== '0') || numSets > 5) {
        theParams.push(buildParamViewTime(type, p6));
    }
    if ((p7 !== null && p7 !== '' && p7 !== '0') || numSets > 6) {
        theParams.push(buildParamViewTime(type, p7));
    }
    if ((p8 !== null && p8 !== '' && p8 !== '0') || numSets > 7) {
        theParams.push(buildParamViewTime(type, p8));
    }
    if ((p9 !== null && p9 !== '' && p9 !== '0') || numSets > 8) {
        theParams.push(buildParamViewTime(type, p9));
    }
    if ((p10 !== null && p10 !== '' && p10 !== '0') || numSets > 9) {
        theParams.push(buildParamViewTime(type, p10));
    }
    return theParams;
}

function buildParamViewTime(type, param) {
    if (type === 4 && param !== '-' && param !== 'MAX') {
        if (param && param !== '') {
            if (param.indexOf(':') > 0) {
                const timeUnitArray = param.split(':');
                param = `${timeUnitArray[0]}:${timeUnitArray[1]}`;
            } else {
                let num = parseFloat(param);
                if (num < 10) return `0:0${num}`;
                else if (num < 60) return `0:${num}`;

                num = 100 * Math.floor(num / 60) + (num % 60);
                const len = parseInt(num).toString().length;
                num = `${num}`;
                param = `${num.substring(0, len - 2)}:${num.substring(
                    len - 2,
                    num.length
                )}`;
            }
        } else {
            param = '-';
        }
    } else if (param === '' || param === null) {
        param = '-';
    }

    return param;
}

function calculateSchemeToSave(type, theParams, secondParam = false) {
    if (theParams.length === 0) return;
    let theSame = true;
    let prev = theParams[0];
    let reps = '';

    // This is the symbol to add (eg. %, lb, LWT) Default is none.
    let symbol = '';
    if (type === workoutParamTypes.WEIGHT) {
        symbol = 'lb';
    } else if (type === workoutParamTypes.WEIGHT_PERCENT) {
        symbol = '%';
    } else if (type === workoutParamTypes.TIME) {
        symbol = 'm:s';
    } else if (type === workoutParamTypes.DISTANCE_YARDS) {
        symbol = 'yd';
    } else if (type === workoutParamTypes.DISTANCE_METERS) {
        symbol = 'm';
    } else if (
        type === workoutParamTypes.HEIGHT_INCHES ||
        type === workoutParamTypes.DISTANCE_INCHES
    ) {
        symbol = 'in';
    } else if (type === workoutParamTypes.CALORIES) {
        symbol = 'cal';
    } else if (type === workoutParamTypes.LINEAR) {
        symbol = 'LWP+';
    } else if (type === workoutParamTypes.DISTANCE_MILES) {
        symbol = 'mi';
    } else if (type === workoutParamTypes.DISTANCE_FEET) {
        symbol = 'ft';
    } else if (type === workoutParamTypes.RPE) {
        symbol = 'RPE';
    } else if (type === workoutParamTypes.WATTS) {
        symbol = 'watts';
    } else if (type === workoutParamTypes.VELOCITY) {
        symbol = 'm/s';
    } else if (type === workoutParamTypes.SECONDS) {
        symbol = 's';
    } else if (type === workoutParamTypes.WEIGHT_KG) {
        symbol = 'kg';
    }

    // build the base abbreviation string
    for (let i = 0; i < theParams.length; i++) {
        const param = theParams[i];
        theSame = theSame && prev === param;
        prev = param;
        const hasTimePrescription =
            type === workoutParamTypes.TIME && param !== '-';
        const hasRepRangePrescription =
            type === workoutParamTypes.REP_RANGE && /^\d+-\d+$/.test(param);
        if (
            isNumeric(param) ||
            param === 'MAX' ||
            hasTimePrescription ||
            hasRepRangePrescription
        ) {
            reps += `${param}, `;
        }
        // turn a dash into an underscore
        else if (param === '-') {
            reps += ' _ ' + ', ';
        }
    }

    // Case: All rep counts are equal.
    // [8,8,8] --> 3 x 8 for first line, [8,8,8] --> 8 for second line
    let result = '';
    if (theSame) {
        result = theParams[0];
        if (!secondParam) {
            result = `${theParams.length} x ${result}`;
        }
    }
    // Case: All rep counts not equal. [6,8,10] --> 6,8,10
    else {
        result = reps.substring(0, reps.length - 2);
    }

    // if the row is all dashes or all empty, return an empty string
    if (theSame && (theParams[0] == '-' || theParams[0] === '')) {
        result = '';
    }
    // If not all dashes or all empty, and if second line, tack on @ and symbol
    else if (secondParam) {
        if (type === workoutParamTypes.LINEAR) {
            result = symbol + result;
        } else {
            result = `@ ${result}${symbol}`;
        }
    } else {
        result += symbol;
    }

    return result;
}

function calculateScheme(type, theParams, secondParam = false) {
    return calculateSchemeToSave(type, theParams, secondParam);
}

function calculateParamCountAbr(setExercise) {
    if (setExercise.param_count == 1) {
        return '1 Set';
    }

    return setExercise.param_count + ' Sets';
}

function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

function parseRepRangeTableValue(value) {
    value = value.replace(/[^0-9-]/g, '');
    value = value.replace(/^-+/g, '');

    const dashIndex = value.indexOf('-');
    let minRep;
    let maxRep;

    if (dashIndex === -1) {
        if (value.length <= 3) {
            return value;
        }
        minRep = value.slice(0, 3);
        maxRep = value
            .slice(3)
            .replace(/-/g, '')
            .slice(0, 3);
        return maxRep ? `${minRep}-${maxRep}` : minRep;
    }

    minRep = value.slice(0, dashIndex).slice(0, 3);
    maxRep = value
        .slice(dashIndex + 1)
        .replace(/-/g, '')
        .slice(0, 3);
    return `${minRep}-${maxRep}`;
}

export const formatRepRange = function(value) {
    value = value.replace(/-+/g, '-').replace(/^-|-$/g, '');

    const parts = value.split('-');
    if (parts.length === 2 && parts[0] !== '' && parts[1] !== '') {
        const min = parseInt(parts[0], 10);
        const max = parseInt(parts[1], 10);
        if (!isNaN(min) && !isNaN(max)) {
            if (min === max) {
                value = `${min}`;
            } else if (min > max) {
                value = `${max}-${min}`;
            }
        }
    }

    return value;
};

export const formatTableValueOnBlur = function(type, value) {
    if (type === workoutParamTypes.REP_RANGE) {
        return formatRepRange(value);
    }

    return value;
};

export const parseTableValue = function(type, value) {
    const isRepRange = type === workoutParamTypes.REP_RANGE;
    const isTime = type === workoutParamTypes.TIME;
    if (isTime) {
        value = parseFloat(value.replace(/[^0-9.]/g, '')).toString();
        const intValue = parseInt(value).toString();
        if (intValue === 'NaN') {
            value = '';
        } else if (intValue.length === 1) {
            value = `00:0${value}`;
        } else if (intValue.length === 2) {
            value = `00:${value}`;
        } else if (intValue.length > 2) {
            value = `${value.substr(0, intValue.length - 2)}:${value.substr(
                intValue.length - 2,
                value.length
            )}`;
        }
    } else if (isRepRange) {
        value = parseRepRangeTableValue(value);
    } else {
        if (value === 'MA') {
            value = '';
        } else if (
            value.length > 0 &&
            value.substring(0, 1).toUpperCase() === 'M'
        ) {
            value = 'MAX';
        }

        if (value !== 'MAX') {
            value = value.replace(/[^0-9.]/g, '');
        }

        if (value.length > 5) {
            value = value.substring(0, 5);
        }
    }

    return value;
};

export const isLift = exercise =>
    _.contains(weightParamTypes, exercise.param_1_type) ||
    _.contains(weightParamTypes, exercise.param_2_type);

/**
 * Filter options by tag
 * @param {Array} options - Option to filter
 * @param {Array} _tags - Tags to use in filter
 * @param {Integer} exId - Exercise selected
 */

export const filterOptionsByTags = function(
    options,
    _tags,
    resultCountMinimum = 10
) {
    const allOptions = options ? [...options] : [];
    let tagsIds = [];
    if (_tags.length > 0) {
        tagsIds = _tags.map(t => parseInt(t.id));
    }

    if (!allOptions) {
        return [];
    }

    if (!tagsIds.length) {
        return allOptions;
    }

    const exerciseIdsMappedToTagMatchCount = mapExerciseToTagMatchCount(
        allOptions,
        tagsIds
    );
    const exerciseIdsWithMatch = _
        .keys(exerciseIdsMappedToTagMatchCount)
        .map(id => parseInt(id));
    const resultExerciseIds = filterExerciseIdsByCountOfTagIds(
        tagsIds,
        exerciseIdsWithMatch,
        exerciseIdsMappedToTagMatchCount,
        resultCountMinimum
    );
    return allOptions.filter(
        option => option.id && _.contains(resultExerciseIds, option.id)
    );
};

const filterExerciseIdsByCountOfTagIds = function(
    tagsIds,
    exerciseIds,
    exerciseIdsMappedToTagMatchCount,
    resultCountMinimum
) {
    let resultExerciseIds = [];

    // Start by adding exercises that match all x filters and then iterate to
    // add exercises that match x - 1 filters, x - 2, and so on. But, we return
    // and kick out of the loop as soon as we have more than resultsCountMinimum
    // results.
    for (let i = tagsIds.length; i > 0; i--) {
        const exerciseIdsForTagCount = exerciseIds.filter(
            id => exerciseIdsMappedToTagMatchCount[id] === i
        );
        resultExerciseIds = resultExerciseIds.concat(exerciseIdsForTagCount);

        if (resultExerciseIds.length >= resultCountMinimum) {
            return resultExerciseIds;
        }
    }

    return resultExerciseIds;
};

const mapExerciseToTagMatchCount = function(allOptions, tagsIds) {
    // Build an object that maps exercise id (from allOptions)
    // to the count of tags (from tagsIds) that it matches.
    const exerciseIdsMappedToTagMatchCount = {};
    _.each(allOptions, option => {
        if (option.id) {
            const optionTagsIds = option.tags.map(t => parseInt(t.id));
            const tagMatches = optionTagsIds.filter(
                tagId => tagsIds.indexOf(tagId) >= 0
            );
            const tagMatchCount = tagMatches.length;

            if (tagMatchCount > 0)
                exerciseIdsMappedToTagMatchCount[option.id] = tagMatchCount;
        }
    });
    return exerciseIdsMappedToTagMatchCount;
};

export const calculatePublishDate = function(session, pub_days, pub_time) {
    if (session) {
        const d = moment(session.date, 'YYYY-M-D');
        d.subtract(pub_days, 'days');
        return `${d.format('M-D-YYYY')} ${convertPubTime(pub_time)}`;
    }
    return '';
};

export const convertPubTime = function(time) {
    if (time === 0) {
        return '12:00AM';
    } else if (time < 12) {
        return `${time}:00AM`;
    } else if (time === 12) {
        return '12:00PM';
    }
    return `${time - 12}:00PM`;
};

export const emptyCircuitTemplate = {
    label: 'Circuit',
    type: BlockTypes.CONDITIONING,
    redzone_type: redzones.COMPLETION,
    plain_text: 1,
    instruction: '',
    redzone_instruction: '',
    test_instruction: '',
    exercises: [],
    exerciseKeys: [],
    workoutSetExercises: [],
    tags: [],
    is_agility: 0,
    is_endurance: 0,
    is_power: 0,
    is_power_endurance: 0,
    is_redzone: 0,
    is_set: 0,
    is_speed: 0,
    is_strength: 0,
    is_test: 0,
    resets_working_max: null,
    smaller_is_better: null,
    workout_id: null,
    workout_combo_id: null
};
